import { render } from "./blindBoxManage.vue?vue&type=template&id=14c858ba&scoped=true"
import script from "./blindBoxManage.vue?vue&type=script&lang=js"
export * from "./blindBoxManage.vue?vue&type=script&lang=js"

import "./blindBoxManage.vue?vue&type=style&index=0&id=14c858ba&scoped=true&lang=css"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c858ba"]])

export default __exports__